import FinalRecommendation from "../../Pages/FinalRecommendation";

const navigation = {
  header: "Final Recommendation",
  links: [
    {
      text: "Final Recommendation",
      icon: <></>,
      route: "",
      component: FinalRecommendation,
    },
  ],
};
export default navigation;
